import { useTranslation } from 'react-i18next';
import { DescriptionColoredButton } from '../../ItemCommons';

interface CardActionsProps {
  isShowDetails: boolean;
  setIsShowDetails: (value: boolean) => void;
  ariaLabel?: string;
}

export const CardActions = ({
  isShowDetails,
  setIsShowDetails,
  ariaLabel,
}: CardActionsProps): JSX.Element => {
  const { t } = useTranslation();
  const text = isShowDetails
    ? t('LINE_ITEMS_HIDE_DETAILS')
    : t('LINE_ITEMS_VIEW_MORE_DETAILS');
  const buttonAriaLabel = `${text} ${ariaLabel}`;

  return (
    <DescriptionColoredButton
      onClick={() => setIsShowDetails(!isShowDetails)}
      aria-label={buttonAriaLabel}
    >
      {text}
    </DescriptionColoredButton>
  );
};
